import { render, staticRenderFns } from "./Colocacao.vue?vue&type=template&id=db045194"
import script from "./Colocacao.vue?vue&type=script&lang=js"
export * from "./Colocacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports